import React, { useState } from 'react';

const REGIONS = [
  // Front
  { id: 'front_bumper', label: 'Frontstoßstange', d: 'M232,82 C238,90 238,110 232,118 L222,120 L222,80 Z', color: '#e2e8f0' },
  { id: 'headlight_left', label: 'Scheinwerfer L', d: 'M228,72 L232,82 L222,80 L222,72 Z', color: '#fef9c3' },
  { id: 'headlight_right', label: 'Scheinwerfer R', d: 'M232,118 L228,128 L222,128 L222,120 Z', color: '#fef9c3' },
  // Hood
  { id: 'hood', label: 'Motorhaube', d: 'M222,68 L222,132 L178,132 L178,68 Z', color: '#f1f5f9' },
  // Windshield
  { id: 'windshield', label: 'Windschutzscheibe', d: 'M178,68 L178,132 L155,130 L155,70 Z', color: '#bfdbfe' },
  // Roof
  { id: 'roof', label: 'Dach', d: 'M155,70 L155,130 L90,130 L90,70 Z', color: '#f8fafc' },
  // Rear window
  { id: 'rear_window', label: 'Heckscheibe', d: 'M90,70 L90,130 L68,132 L68,68 Z', color: '#bfdbfe' },
  // Trunk
  { id: 'trunk', label: 'Kofferraum', d: 'M68,68 L68,132 L24,128 L24,72 Z', color: '#f1f5f9' },
  // Rear bumper
  { id: 'rear_bumper', label: 'Heckstoßstange', d: 'M24,72 L24,128 L18,118 C12,110 12,90 18,82 Z', color: '#e2e8f0' },
  { id: 'taillight_left', label: 'Rücklicht L', d: 'M24,72 L24,68 L18,72 L18,82 Z', color: '#fecaca' },
  { id: 'taillight_right', label: 'Rücklicht R', d: 'M24,128 L24,132 L18,128 L18,118 Z', color: '#fecaca' },
  // Left side (top in landscape = driver side)
  { id: 'left_front_fender', label: 'Kotflügel VL', d: 'M228,72 L222,72 L222,68 L178,68 L178,58 Q178,48 190,48 L210,48 Q222,48 228,60 Z', color: '#e2e8f0' },
  { id: 'left_front_door', label: 'Tür VL', d: 'M178,58 L178,68 L155,70 L122,70 L122,58 Z', color: '#eef2ff' },
  { id: 'left_rear_door', label: 'Tür HL', d: 'M122,58 L122,70 L90,70 L68,68 L68,58 Z', color: '#eef2ff' },
  { id: 'left_rear_fender', label: 'Kotflügel HL', d: 'M68,58 L68,68 L24,72 L24,68 Q24,48 40,48 L56,48 Q68,48 68,58 Z', color: '#e2e8f0' },
  // Right side (bottom in landscape = passenger side)
  { id: 'right_front_fender', label: 'Kotflügel VR', d: 'M228,128 Q222,152 210,152 L190,152 Q178,152 178,142 L178,132 L222,132 L222,128 Z', color: '#e2e8f0' },
  { id: 'right_front_door', label: 'Tür VR', d: 'M178,132 L178,142 L122,142 L122,130 L155,130 Z', color: '#eef2ff' },
  { id: 'right_rear_door', label: 'Tür HR', d: 'M122,130 L122,142 L68,142 L68,132 L90,130 Z', color: '#eef2ff' },
  { id: 'right_rear_fender', label: 'Kotflügel HR', d: 'M68,132 L68,142 Q68,152 56,152 L40,152 Q24,152 24,132 L24,128 Z', color: '#e2e8f0' },
  // Mirrors
  { id: 'left_mirror', label: 'Spiegel L', d: 'M172,52 L178,56 L168,58 L168,52 Z', color: '#cbd5e1' },
  { id: 'right_mirror', label: 'Spiegel R', d: 'M178,144 L172,148 L168,148 L168,142 Z', color: '#cbd5e1' },
  // Tires
  { id: 'tire_front_left', label: 'Reifen VL', d: 'M188,38 L212,38 L212,48 L188,48 Z', color: '#1e293b' },
  { id: 'tire_front_right', label: 'Reifen VR', d: 'M188,152 L212,152 L212,162 L188,162 Z', color: '#1e293b' },
  { id: 'tire_rear_left', label: 'Reifen HL', d: 'M38,38 L62,38 L62,48 L38,48 Z', color: '#1e293b' },
  { id: 'tire_rear_right', label: 'Reifen HR', d: 'M38,152 L62,152 L62,162 L38,162 Z', color: '#1e293b' },
];

export default function DamageRegionSelector({ selectedRegions = [], onChange }) {
  const [hovered, setHovered] = useState(null);

  const toggle = (id) => {
    onChange(selectedRegions.includes(id) ? selectedRegions.filter(r => r !== id) : [...selectedRegions, id]);
  };

  return (
    <div className="flex flex-col lg:flex-row gap-6 items-start">
      <div className="flex-1 w-full">
        {/* Labels */}
        <div className="flex justify-between items-center px-4 mb-1">
          <span className="text-[10px] text-gray-500 font-semibold tracking-widest uppercase">Hinten</span>
          <span className="text-[10px] text-gray-400 font-medium tracking-widest uppercase">Fahrerseite</span>
          <span className="text-[10px] text-gray-500 font-semibold tracking-widest uppercase">Vorne</span>
        </div>

        <div className="bg-white rounded-xl p-2">
          <svg viewBox="5 30 240 140" className="w-full" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <filter id="carShadow" x="-5%" y="-5%" width="110%" height="110%">
                <feDropShadow dx="0" dy="1" stdDeviation="1.5" floodColor="#94a3b8" floodOpacity="0.12"/>
              </filter>
            </defs>

            {/* Body outline */}
            <path d="M18,82 C12,90 12,110 18,118 L24,128 Q24,152 40,152 L62,152 L62,162 L212,162 L212,152 L210,152 Q222,152 228,140 L232,118 C238,110 238,90 232,82 L228,60 Q222,48 210,48 L212,38 L62,38 L62,48 L40,48 Q24,48 24,68 Z"
              fill="none" stroke="#cbd5e1" strokeWidth="0.8" filter="url(#carShadow)"/>

            {/* Regions */}
            {REGIONS.map((r) => {
              const sel = selectedRegions.includes(r.id);
              const hov = hovered === r.id;
              const isTire = r.id.startsWith('tire');
              const isGlass = r.id === 'windshield' || r.id === 'rear_window';

              let fill = r.color;
              if (sel) fill = 'rgba(239,68,68,0.5)';
              else if (hov) fill = 'rgba(41,190,255,0.35)';

              return (
                <path
                  key={r.id}
                  d={r.d}
                  fill={fill}
                  stroke={sel ? '#dc2626' : hov ? '#29beff' : isTire ? '#0f172a' : isGlass ? '#93c5fd' : '#cbd5e1'}
                  strokeWidth={sel ? '1.8' : hov ? '1.2' : '0.6'}
                  className="cursor-pointer transition-all duration-150"
                  onClick={() => toggle(r.id)}
                  onMouseEnter={() => setHovered(r.id)}
                  onMouseLeave={() => setHovered(null)}
                />
              );
            })}

            {/* Pillar lines */}
            <line x1="155" y1="58" x2="155" y2="70" stroke="#93c5fd" strokeWidth="0.4" />
            <line x1="155" y1="130" x2="155" y2="142" stroke="#93c5fd" strokeWidth="0.4" />
            <line x1="90" y1="58" x2="90" y2="70" stroke="#93c5fd" strokeWidth="0.4" />
            <line x1="90" y1="130" x2="90" y2="142" stroke="#93c5fd" strokeWidth="0.4" />
            <line x1="122" y1="58" x2="122" y2="70" stroke="#94a3b8" strokeWidth="0.5" />
            <line x1="122" y1="130" x2="122" y2="142" stroke="#94a3b8" strokeWidth="0.5" />

            {/* Door handles */}
            <rect x="140" y="60" width="1.5" height="4" rx="0.5" fill="#94a3b8" />
            <rect x="108" y="60" width="1.5" height="4" rx="0.5" fill="#94a3b8" />
            <rect x="140" y="136" width="1.5" height="4" rx="0.5" fill="#94a3b8" />
            <rect x="108" y="136" width="1.5" height="4" rx="0.5" fill="#94a3b8" />

            {/* Hood/trunk lines */}
            <line x1="182" y1="100" x2="218" y2="100" stroke="#cbd5e1" strokeWidth="0.3" />
            <line x1="28" y1="100" x2="64" y2="100" stroke="#cbd5e1" strokeWidth="0.3" />

            {/* Rim circles */}
            <circle cx="200" cy="43" r="3.5" fill="none" stroke="#475569" strokeWidth="0.5" />
            <circle cx="200" cy="43" r="1.5" fill="#64748b" />
            <circle cx="200" cy="157" r="3.5" fill="none" stroke="#475569" strokeWidth="0.5" />
            <circle cx="200" cy="157" r="1.5" fill="#64748b" />
            <circle cx="50" cy="43" r="3.5" fill="none" stroke="#475569" strokeWidth="0.5" />
            <circle cx="50" cy="43" r="1.5" fill="#64748b" />
            <circle cx="50" cy="157" r="3.5" fill="none" stroke="#475569" strokeWidth="0.5" />
            <circle cx="50" cy="157" r="1.5" fill="#64748b" />

            {/* Front grill lines */}
            <line x1="230" y1="92" x2="230" y2="108" stroke="#90a4ae" strokeWidth="0.4" />
            <line x1="233" y1="94" x2="233" y2="106" stroke="#90a4ae" strokeWidth="0.3" />

            {/* Number badges */}
            {REGIONS.map((r) => {
              if (!selectedRegions.includes(r.id)) return null;
              const idx = selectedRegions.indexOf(r.id) + 1;
              const pts = r.d.match(/(\d+),(\d+)/g)?.map(p => p.split(',').map(Number)) || [];
              if (!pts.length) return null;
              const cx = pts.reduce((s, p) => s + p[0], 0) / pts.length;
              const cy = pts.reduce((s, p) => s + p[1], 0) / pts.length;
              return (
                <g key={`b-${r.id}`}>
                  <circle cx={cx} cy={cy} r="5" fill="#dc2626" />
                  <text x={cx} y={cy + 2.5} textAnchor="middle" fill="white" fontSize="6" fontWeight="bold">{idx}</text>
                </g>
              );
            })}
          </svg>
        </div>

        <div className="flex justify-center mt-1">
          <span className="text-[10px] text-gray-400 font-medium tracking-widest uppercase">Beifahrerseite</span>
        </div>
      </div>

      {/* Selected regions */}
      <div className="lg:w-48 flex-shrink-0 w-full">
        <p className="text-sm font-medium text-gray-700 mb-3">
          Beschädigte Bereiche
          {selectedRegions.length > 0 && <span className="text-red-500 ml-1">({selectedRegions.length})</span>}
        </p>
        {selectedRegions.length === 0 ? (
          <p className="text-xs text-gray-400 leading-relaxed">Klicken Sie auf das Fahrzeug um beschädigte Bereiche zu markieren.</p>
        ) : (
          <div className="flex flex-wrap gap-1.5">
            {selectedRegions.map((id, idx) => {
              const region = REGIONS.find(r => r.id === id);
              return (
                <button key={id} onClick={() => toggle(id)}
                  className="inline-flex items-center gap-1.5 px-2.5 py-1.5 bg-red-50 border border-red-200 rounded-md text-xs text-red-700 hover:bg-red-100 transition-colors">
                  <span className="w-4 h-4 bg-red-500 rounded-full flex items-center justify-center text-white text-[8px] font-bold flex-shrink-0">{idx + 1}</span>
                  {region?.label}
                  <span className="text-red-300 ml-0.5">&times;</span>
                </button>
              );
            })}
          </div>
        )}
        {hovered && !selectedRegions.includes(hovered) && (
          <div className="mt-3 px-2.5 py-1.5 bg-blue-50 border border-blue-200 rounded-md">
            <p className="text-xs text-[#29beff] font-medium">{REGIONS.find(r => r.id === hovered)?.label}</p>
          </div>
        )}
      </div>
    </div>
  );
}
